import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class HTTPrequestService {


  constructor( private _http:HttpClient ) { }

  requestPost(url:string, body:any){
    let body1 = JSON.stringify(body);
    let headers = new HttpHeaders({
      'Content-Type':'application/json'
    })
    return this._http.post( url, body1, { headers }  )
    .pipe(map( resp=>{  return resp } ))
  }

  requestFilePost(url:string, file:any){
    // let headers = new HttpHeaders({
    //   'Content-Type':'multipart/form-data'
    // })
    return this._http.post( url, file  )
    .pipe(map( resp=>{  return resp } ))
  }

  requestGet( url:string ){
    let headers = new HttpHeaders({
      'Content-Type':'text/html'
    })

    return this._http.get( url, { headers }  )
    .pipe(map( resp=>{ return resp } ))
  }

  requestUpdate(url:string, body:any){
    let body1 = JSON.stringify(body);
    let headers = new HttpHeaders({
      'Content-Type':'application/json'
    })
    return this._http.put( url, body1, { headers }  )
    .pipe(map( resp=>{  return resp } ))
  }

  requestDelete( url:string ){

    return this._http.delete( url )
    .pipe(map( resp=>{ return resp } ))
  }

}
